import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

export default function AdminCredentialVerification() {
  const navigate = useNavigate();
  useEffect(() => { navigate('/admin/verification-queue', { replace: true }); }, [navigate]);
  return null;
}
